const DEVICE_ID_STORAGE_KEY = 'malenia:device-id';

// Stable per-browser device id for push registration (regenerated if storage is cleared).
export const getDeviceId = (): string => {
  let deviceId = localStorage.getItem(DEVICE_ID_STORAGE_KEY);
  if (!deviceId) {
    deviceId = crypto.randomUUID();
    localStorage.setItem(DEVICE_ID_STORAGE_KEY, deviceId);
  }
  return deviceId;
};
